export const JOB_STATUS ={
    progress:'IN_PROGRESS',
    complete:'COMPLETE',
} as const

export const TASK_VIEW={
taskQuality:'task-quality',
manualComplete:'manual-complete',
info:'info',
} as const
  
export const TOAST_OPTIONS={
    success: {
      style: {
        background: '#166534',
         color:'#dcfce7',
         fontSize:'12px',
         fontWeight:'500'
      },
    },
    error: {
      style: {
        background: '#fee2e2',
        color:'#ef4444',
        fontSize:'12px',
        fontWeight:'500'
      },
    },
  }